<template>
    <div class="wire-transfer">
      <div class="title">线下签订</div>
      <Step :arr="arr" class="mt-6 mb-6 title2"></Step>
    <div class="content">
      <div class="prompt">
        <div>
          <div>
          <p>
            <span>注意事项:</span>
          </p>
          <p>
            <span>1、请点击下载承诺书文件（即投标委托保证合同），打印盖公章，并将扫描件上传至本系统</span>
          </p>
          <p>
            <span>2、上传文件格式支持PDF、图片</span>
          </p>
          <p>
            <span>3、下载的文件请勿修改，打印后直接盖章即可</span>
          </p>
          </div>
          <!-- <div v-if="this.apiId === 'ahyd'" class="font-red">
            注意：必须公对公转账
          </div> -->
        </div>
      </div>
    </div>
    <div class="text-center">
    <el-button
      type="primary"
      style="margin-left: 10px"
      class="mt-3 mb-3"
      @click="goDownload"
    >
      下载承诺书文件 <i class="el-icon-download el-icon--right"></i
    ></el-button>
    <el-upload
      class="upload-demo inline-block"
      style="margin-left: 20px"
      :show-file-list="false"
      :multiple="false"
      :limit="1"
      ref="upload"
      action="/zcjf/base/file/upload"
      :on-remove="handleRemove"
      :on-preview="handlePreview"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :on-error="handleUploadError"
      :before-upload="beforeAvatarUpload"
      :data="actionData"
      v-if="type === 0"
      accept =".png, .jpg, .jpeg, .pdf"
    >
      <el-button type="primary" class="mt-3 mb-3" :loading="uploadLoading"
        >上传承诺书扫描件 <i class="el-icon-upload el-icon--right"></i
      ></el-button>
    </el-upload>
    <el-button v-else-if="type === 1" type="primary" class="mt-3 mb-3"  @click="goPay"
        >{{ payTitle }} <i class="el-icon-right  el-icon--right"></i
      ></el-button>
  </div>
</div>
</template>
<script>
import Step from '../../components/CA/Step'
import pdf from '../../components/pdf/pdf'
import { uploadUndertaking } from '@/api/order'
import { download3 } from '@/shared/file'
import uploadE from '../../common/upload/uoload.vue'
import { pay } from '@/shared/pay'
import { queryOrderDetail } from '@/api/order'
export default {
  name: 'insuranceLetterCmmmit.vue',
  data() {
    return {
      actionData: {
        module1: 'bfe',
        module2: 'bfe_guarantee_main',
      },
      fileList: [],
      pdfUrl: '',
      arr: [
        { icon: 1, span: '保函样张确认', status: 'finish', time: '' },
        { icon: 2, span: '上传扫描件', status: 'active', time: '' },
        { icon: 3, span: '去支付', status: 'wait', time: '' },
      ],
      query: {}, // fixed ie bug
      fileId: null,
      commitmentPdfSginId: null,
      guaranteeApplyStatus: null,
      uploadLoading: false,
      type:0,
      applyType: null,
      basicPay: null,
      payTitle: '已上传成功,去支付',
    }
  },

  components: {
    Step,
    pdf,
    UP: uploadE,
  },
  computed: {
    isUploadTransfer() {
      // 线下支付判断条件:  电子担保保函并且支付方式-是基本户打款
      return this.applyType === '9600' && this.basicPay === '1'
    },
  },
  beforeMount() {
    this.query = this.$route.query
    this.pdfUrl = '/zcjf/base/file/download/' + this.$route.query.pdfID
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      const { orderId } = this.$route.query
    if (orderId) {
      queryOrderDetail(orderId).then((res) => {
        this.commitmentPdfSginId = res.data.commitmentPdfSginId
        this.guaranteeApplyStatus = res.data.guaranteeApplyStatus
        this.applyType = res.data.applyType
        this.basicPay = res.data.basicPay
        if(this.isUploadTransfer){
            this.arr[2].span = '上传电汇底单'
          }
        if (this.commitmentPdfSginId && this.guaranteeApplyStatus === '1000') {
          this.fileId = this.commitmentPdfSginId
          this.$refs.upload.clearFiles()
          this.arr[1].status = 'finish'
          this.arr[2].status = 'active'
          this.type = 1
          if(this.isUploadTransfer){
            this.payTitle = '已上传成功,去上传电汇底单'
            this.arr[2].span = '上传电汇底单'
          }
        }else if( this.guaranteeApplyStatus == '4000'){
          this.arr[1].span = '重新上传承诺书'
        }else if(this.commitmentPdfSginId && this.guaranteeApplyStatus >= 2000){
          return this.$router.push({
          path: '/orderDetail',
          query: {
            order: orderId,
          },
        })
        }
      })
    }
    },
    goDownload() {
      const { orderId } = this.$route.query
      download3(this.$route.query.pdfID,orderId+'_'+'投保单.pdf')
    },
    goPay() {
      if (!this.fileId) {
        this.$message.error('请先上传扫描件')
        return
      }
      const { orderId } = this.$route.query
      if (this.isUploadTransfer) {
        // 线下支付
        return this.$router.push({
          path: '/wire-transfer',
          query: {
            order: orderId,
          },
        })
      }
      this.payLoading = true
      pay.call(this, orderId)
        .then((v) => {
          this.payLoading = false
        })
    },
    uploadSuccess(res) {
      this.form.tenderFileId = res.url
      this.$refs.form.validateField('tenderFileId')
    },
    handleExceed() {
      this.$message.warning(
        '上传超过限制，只能上传1个文件，请删除当前文件后操作'
      )
    },
    handlePreview(file) {
      console.log(file)
    },
    //文件移除钩子，用于清理fileId
    handleRemove(file, fileList) {
      this.$emit('fileIdCb', { url: '' })
    },
    // 文件上传成功钩子函数
    handleUploadSuccess(res, file) {
      const { orderId } = this.$route.query
      uploadUndertaking({
        fileId: res.url,
        orderId: orderId,
      }).then((v) => {
        if (v.code === 200) {
          if (this.guaranteeApplyStatus === '4000') {
            this.$message.success('投保单上传成功,订单待出函')
            return this.$router.push({
              path: '/orderDetail',
              query: {
                order: orderId,
              },
            })
          }else{
            this.$message.success('投保单上传成功！')
          }
          this.init()
        }
        this.uploadLoading = false
        this.$refs.upload.clearFiles()
      }).catch(() => {
        this.uploadLoading = false
        this.$refs.upload.clearFiles()             
      })

    
    },
    handleUploadError(err, file, fileList) {
      this.$message.success('上传失败')
      this.uploadLoading = false
    },

    // 文件上传拦截
    beforeAvatarUpload(file) {
      this.uploadLoading = true
      if (file.size > 1073741824) {
        this.$message.error(
          '上传文件大小超过限制！请上传小于' +
            this.maxSize / 1024 / 1024 +
            'MB大小的文件'
        )
        return false
      }
      let fileType = file.name
        .substring(file.name.lastIndexOf('.') + 1)
        .toLowerCase()
      let filetypes = ['png', 'jpg', 'jpeg', 'pdf']
      if (filetypes.indexOf(fileType) === -1) {
        this.$message.error('上传文件格式不正确')
        return false
      }
    },
  },
}
</script>
<style type="text/css">
.inline-block {
  display: inline-block;
  
}

</style>

<style lang="scss" scoped>
  .wire-transfer {
    width: 1000px;
    height: 600px;
    background-color: white;
    padding: 20px;
    margin: 0 auto;
    border-radius: 4px;
    .title {
      font-size: 24px;
      font-weight: normal;
      text-align: center;
    }
    .title2{
      padding-bottom: 30px;
      border-bottom: 1px solid #eee;
    }
    .content {
      font-size: 16px;
      width: 676px;
      margin: 46px auto;
      em {
        color: #f52f3e;
        font-style: normal;
        font-size: 28px;
      }
      .prompt {
        display: flex;
        justify-content: space-between;
        background-color: #fff4f4;
        padding: 20px 30px;
        margin-top: 20px;
        line-height: 2;
        overflow: hidden;
        .font-red {
          font-size: 18px;
          color: red;
        }
      }
    }
  }
  </style>
  